import Register from './RegisterContainer';

export { Register };



// WEBPACK FOOTER //
// ./src/modules/sign/Register/index.js